import { CompleteProfilePage } from '@/features/auth'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/(auth)/complete-profile')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CompleteProfilePage />
}
